/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { flattenEmbedded } from './util/flattenEmbedded.js';
class AuthnTransactionImpl {
  constructor(sdk, tx) {
    let res = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    this.data = undefined;
    this.status = undefined;
    if (res) {
      this.data = res;
      Object.assign(this, flattenEmbedded(sdk, tx, res, res, {}));
      delete this.stateToken;
      if (res.status === 'RECOVERY_CHALLENGE' && !res._links) {
        this.cancel = function () {
          return Promise.resolve(tx.createTransaction());
        };
      }
    }
  }
}
export { AuthnTransactionImpl };